import { useEffect } from 'react';
import { transferNoticeUrl } from '../../utils/transferNotice';

/**
 * 이력서 등록·조회 경로를 브이매치 이전 안내 페이지로 넘긴다.
 *
 * 안내 페이지는 React Router 밖의 정적 파일이라 <Navigate> 로는 이동할 수 없어
 * window.location.replace 로 전체 이동시킨다. replace 를 쓰는 이유는 뒤로가기로
 * 다시 차단된 경로에 들어오는 것을 막기 위함이다.
 */
const TransferRedirect = ({ from }) => {
  useEffect(() => {
    window.location.replace(transferNoticeUrl(from));
  }, [from]);

  // 이동 직전 잠깐 노출되는 대체 화면 — 스크린리더에도 상태를 알린다.
  return (
    <div
      className="flex min-h-screen items-center justify-center px-5 text-center"
      role="status"
      aria-live="polite"
    >
      <p className="text-[15px] leading-7 text-[#374151]">
        이력서 서비스가 브이매치로 변경되었습니다.
        <br />
        안내 페이지로 이동합니다.{' '}
        <a
          href={transferNoticeUrl(from)}
          className="font-[700] text-[#0F8F84] underline underline-offset-4"
        >
          바로 이동하기
        </a>
      </p>
    </div>
  );
};

export default TransferRedirect;
